import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import parseJwt from '../utils/jwt';
import { useAuth } from '../context/AuthContext';

function useSessionTimeout(refreshTokenCallback) {
  const navigate = useNavigate();
  const { token, logout, setToken } = useAuth();
  const [showRenewModal, setShowRenewModal] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }

    const decoded = parseJwt(token);
    if (!decoded?.exp) {
      logout();
      navigate('/login');
      return;
    }

    const expirationTime = decoded.exp * 10000;
    const now = Date.now();
    const timeLeft = expirationTime - now;

    if (timeLeft <= 0) {
      logout();
      navigate('/login');
      return;
    }

    const alertTime = timeLeft - 4 * 60 * 10000; // 28 minutos antes

    if (alertTime <= 0) {
      setShowRenewModal(false);
    } else {
        const timeoutId = setTimeout(() => setShowRenewModal(false), alertTime);
      return () => clearTimeout(timeoutId);
    }
  }, [token, logout, navigate]);

  const renewSession = async () => {
    try {
      const newToken = await refreshTokenCallback();
      if (newToken) {
        setToken(newToken);  // Actualiza token en contexto
        setShowRenewModal(false);
      } else {
        throw new Error('No se recibió token nuevo');
      }
    } catch (error) {
      console.error('Error renovando sesión:', error);
      logout();
      navigate('/login');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return { showRenewModal, renewSession, logout: handleLogout, setShowRenewModal };
}

export default useSessionTimeout;
